import React from 'react';
import PropTypes from 'prop-types';
import AskVaLinkWithRouter from '../AskVaLink';

/**
 * @typedef {object} DefaultStartUiProps
 * @property {string} href - The start page path to navigate to
 * @property {React.MouseEventHandler} [onStart] - Optional click handler; if provided, called instead of navigating to href. Use when prefill needs to be fetched.
 */

/** @param {DefaultStartUiProps} props */
export default function DefaultStartLink({ href, onStart }) {
  return (
    <va-card>
      <h3 className="vads-u-margin--0">Ask a new question</h3>
      <p className="vads-u-margin-y--1">
        Ask us a question online and get a personalized response. We’ll guide
        you through the process step by step. This form takes about 10 to 15
        minutes to complete.
      </p>
      <AskVaLinkWithRouter
        variant="action.secondary"
        text="Ask a question"
        onClick={onStart}
        {...{ href }}
      />
    </va-card>
  );
}

DefaultStartLink.propTypes = {
  href: PropTypes.string.isRequired,
  onStart: PropTypes.func,
};
